module.exports = __webpack_public_path__ + "img/aston-apply.9af390ee.webp";